import script from "./select.vue?vue&type=script&setup=true&lang=js"
export * from "./select.vue?vue&type=script&setup=true&lang=js"

import "./select.vue?vue&type=style&index=0&id=1318934a&lang=css"

const __exports__ = script;

export default __exports__